module.exports = __webpack_public_path__ + "img/slidebar.d1683bb1.png";